import script from "./ResetAmountDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetAmountDialog.vue?vue&type=script&setup=true&lang=js"

import "./ResetAmountDialog.vue?vue&type=style&index=0&id=1ac18be7&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac18be7"]])

export default __exports__